import type { ODataOperator } from "../../declarations/ODataExplorer";

const STRING_OPS: ODataOperator[] = ["eq", "ne", "contains", "startswith", "endswith", "is null", "is not null"];
const NUMERIC_OPS: ODataOperator[] = ["eq", "ne", "gt", "ge", "lt", "le", "is null", "is not null"];
const BOOLEAN_OPS: ODataOperator[] = ["eq", "ne", "is null", "is not null"];
const ENUM_OPS: ODataOperator[] = BOOLEAN_OPS;

const NUMERIC_TYPES = new Set([
    "Edm.Byte", "Edm.Int16", "Edm.Int32", "Edm.Int64",
    "Edm.Single", "Edm.Double", "Edm.Decimal",
    "Edm.Date", "Edm.DateTime", "Edm.DateTimeOffset", "Edm.TimeOfDay",
]);

export function allowedOperators(edmType: string, enumTypeName: string | null): ODataOperator[] {
    if (enumTypeName) return [...ENUM_OPS];
    if (edmType === "Edm.Boolean") return [...BOOLEAN_OPS];
    if (NUMERIC_TYPES.has(edmType)) return [...NUMERIC_OPS];
    if (edmType === "Edm.String" || edmType === "Edm.Guid") return [...STRING_OPS];
    return [...STRING_OPS];
}

export type ValueControlKind = "text" | "number" | "date" | "boolean" | "enum" | "none";

export function valueControlKind(
    edmType: string,
    enumTypeName: string | null,
    op: ODataOperator,
): ValueControlKind {
    if (op === "is null" || op === "is not null") return "none";
    if (enumTypeName) return "enum";
    if (edmType === "Edm.Boolean") return "boolean";
    if (edmType === "Edm.Date" || edmType === "Edm.DateTime" || edmType === "Edm.DateTimeOffset") return "date";
    if (NUMERIC_TYPES.has(edmType)) return "number";
    return "text";
}
